import { ALL_FEEDSTOCK_KEYS, FeedstockKey, SHARE_RANGE } from '../types/emission-factor.constants';

export { fromPercent, toPercent } from '../../../shared/utils/formatters.utils';

const SHARE_TOTAL_EPSILON = 1e-9;

export function validateShareValue(value: number | null): string | null {
   if (value === null) return null;
   if (value < SHARE_RANGE.MIN) return `Share must be at least ${SHARE_RANGE.MIN * 100}%`;
   if (value > SHARE_RANGE.MAX) return `Share must not exceed ${SHARE_RANGE.MAX * 100}%`;
   return null;
}

const formatSharePercent = (total: number): string =>
   `${(total * 100).toFixed(2).replace(/\.?0+$/, '')}%`;

export function validateYearlyShares(shares: Record<FeedstockKey, number | null>): Record<FeedstockKey, string | null> {
   const result = ALL_FEEDSTOCK_KEYS.reduce((acc, key) => {
      acc[key] = validateShareValue(shares[key]);
      return acc;
   }, {} as Record<FeedstockKey, string | null>);

   if (Object.values(result).some((e) => e !== null)) return result;

   const total = ALL_FEEDSTOCK_KEYS.reduce((sum, key) => sum + (shares[key] ?? 0), 0);
   if (total <= 0 || Math.abs(total - 1) <= SHARE_TOTAL_EPSILON) return result;

   const totalError =
      total > 1
         ? `Total share exceeds 100% (sum: ${formatSharePercent(total)})`
         : `Total share must equal 100% (sum: ${formatSharePercent(total)})`;

   ALL_FEEDSTOCK_KEYS.forEach((key) => {
      if ((shares[key] ?? 0) > 0) result[key] = totalError;
   });

   return result;
}
